import isGHMC, { getCurrentDate } from "../../../../Common/helper/helpar";
import { Formik, Form, Field } from "formik";
import { useEffect, useState } from "react";
import MSWManagementTertiaryCollectionStore from "./store/MSWManagementTertiaryCollectionStore";
import { MSWManagementTertiaryVehiclesExport } from "./MSWManagementTertiaryVehiclesExport";

export const MSWManagementTertiaryVehiclesFilter = () => {
  const {
    fetchMSWManagementTertiaryCollectionReport,
    MSWManagementTertiaryCollectionReportData,
    loading,
  } = MSWManagementTertiaryCollectionStore();

  const isProd = isGHMC();
  const todayDate = getCurrentDate(); // YYYY-MM-DD

  const defaultValues = {
    FromDate: todayDate,
    ToDate: todayDate,
  };

  const [initialFilterValues, setInitialFilterValues] = useState(defaultValues);

  /* ================= LOAD FROM LOCALSTORAGE ================= */
  useEffect(() => {
    const storedFilters = localStorage.getItem("mswTertiaryVehiclesFilters");

    if (storedFilters) {
      const parsed = JSON.parse(storedFilters);
      setInitialFilterValues(parsed);
      fetchMSWManagementTertiaryCollectionReport(parsed);
    } else {
      localStorage.setItem("mswTertiaryVehiclesFilters", JSON.stringify(defaultValues));
      fetchMSWManagementTertiaryCollectionReport(defaultValues);
    }
  }, []);

  /* ================= SUBMIT ================= */
  const handleSubmit = (values) => {
    localStorage.setItem("mswTertiaryVehiclesFilters", JSON.stringify(values));
    fetchMSWManagementTertiaryCollectionReport(values);
  };

  /* ================= RESET ================= */
  const handleReset = (resetForm) => {
    resetForm({ values: defaultValues });
    localStorage.setItem("mswTertiaryVehiclesFilters", JSON.stringify(defaultValues));
    fetchMSWManagementTertiaryCollectionReport(defaultValues);
  };

  return (
    <Formik enableReinitialize initialValues={initialFilterValues} onSubmit={handleSubmit}>
      {({ values, resetForm }) => (
        <Form>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div className="d-flex align-items-end gap-2 mb-2">

              {/* From Date */}
              <div style={{ width: "200px" }}>
                <label className="form-label w-100 text-left">From Date</label>
                <Field
                  type="date"
                  name="FromDate"
                  className="form-control bg-white"
                  max={values.ToDate || todayDate}
                  required
                />
              </div>

              {/* To Date */}
              <div style={{ width: "200px" }}>
                <label className="form-label w-100 text-left">To Date</label>
                <Field
                  type="date"
                  name="ToDate"
                  className="form-control bg-white"
                  min={values.FromDate}
                  max={todayDate}
                  required
                />
              </div>

              <button type="submit" className={`btn ${isProd ? "search-ghmc" : "search-swm"}`}>
                Search
              </button>

              <button
                type="button"
                className={`btn ${isProd ? "search-ghmc" : "search-swm"}`}
                onClick={() => handleReset(resetForm)}
              >
                Reset
              </button>
            </div>

            <div className="mt-4 d-flex">
              <MSWManagementTertiaryVehiclesExport
                data={MSWManagementTertiaryCollectionReportData}
                loading={loading}
                fromDate={values.FromDate}
                toDate={values.ToDate}
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
